import { INTERNAL_REFERENCE_REGEX, PHONE_NUMBER_REGEX } from 'constants/regex';
import DOMPurify from 'dompurify';
import { i18n as I18n } from 'utils/i18n';
import * as yup from 'yup';

export const phoneNumber = (
  label: string = I18n.t('registration.user_details.fields.phone_number.label'),
  required = true,
  schema: ReturnType<typeof yup.string> = yup.string().required() as ReturnType<
    typeof yup.string
  >
) =>
  schema.label(label).matches(PHONE_NUMBER_REGEX, {
    excludeEmptyString: !required,
    message: I18n.t('validations.invalid', { name: label }),
  });

// The messages below are functions, not strings. These schemas are built at
// module scope, so a string would be resolved before i18next is initialised and
// the raw key would surface as the validation error. Yup accepts a message
// function and calls it when the rule actually fails, by which point the
// translations are loaded.
export const clientServiceIds = yup
  .array()
  .notRequired()
  .when('serviceLevel', {
    is: (val: unknown) => val === 'client',
    then: schema => schema.notRequired(),
    otherwise: schema =>
      schema.min(1, () =>
        I18n.t('payment_methods.form.validations.client_service_ids')
      ),
  });

export const internalReference = yup
  .string()
  .ensure()
  .trim()
  .matches(INTERNAL_REFERENCE_REGEX, {
    message: () => I18n.t('basket.internal_ref.modal.validations.internal_ref'),
    excludeEmptyString: true,
  });

export const validateXSS = (value: string): boolean => {
  const cleanValue = DOMPurify.sanitize(value);
  return value === cleanValue;
};

// Passed straight to yup's `.test(name, message, fn)` as a message function, so
// the call sites are unchanged.
export const xssErrorMessage = () => I18n.t('validations.xss');
